const { serviceWorker } = navigator;

if (serviceWorker) {
  await serviceWorker.register("/sw.js");
  location.reload();
}
